import { render, staticRenderFns } from "./Rental.vue?vue&type=template&id=0d4fabc2"
import script from "./Rental.vue?vue&type=script&lang=js"
export * from "./Rental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports